import React from "react";
import { NewIconSelector } from "../BuilderComponents/Preview/IconPreview";
import Input from "../FormComponents/Input";

const EditRVTableCatalogToggler = ({ setEditElementData, editElementData }) => {
  const handleEditElementData = (type, value) => {
    setEditElementData({ ...editElementData, [type]: value });
  };
  const { catalog, table } = editElementData;
  return (
    <div className="builder_form">
      <h3>Table</h3>
      <EditTitleAndIcon
        data={catalog}
        onChange={(newCatalogData) => handleEditElementData("catalog", newCatalogData)}
      />
      <h3>Catalog</h3>
      <EditTitleAndIcon data={table} onChange={(newTableData) => handleEditElementData("table", newTableData)} />
    </div>
  );
};

const EditTitleAndIcon = ({ data, onChange }) => {
  const icon = data?.icon?.split(" ")[0] || "";
  const handleOnChange = (type, value) => {
    onChange({ ...data, [type]: value });
  };
  return (
    <div className="builder_form">
      <Input
        value={data.title}
        name="title"
        label="Enter Title"
        onChange={(e) => handleOnChange("title", e.target.value)}
      />
      <NewIconSelector onChange={(newIcon) => handleOnChange("icon", newIcon)} icon={icon} />
    </div>
  );
};

export default EditRVTableCatalogToggler;
